<template>
  
    
      <Calendar
        v-model="value"
        selectionMode="single"
        dateFormat="yy/mm/dd"
        :showTime="false"
        @date-select="onChange($event)"
        @input="onChange($event)"
        :required="required"
        :disabled="disabled"
      />
   
  </template>
   
  <script>
  export default {
    props: ["modelValue", "label", "required", "disabled"],
    emits: ["update:modelValue", "change"],
  
    data() {
      return {
        value: null,
      };
    },
    created() {
      this.value = this.modelValue;
    },
    watch:{
      modelValue(){
        if( this.modelValue){
          this.value = this.modelValue;
        }
        
      }
    },
    methods: {
        format_date_yyyymmdd(mdate){
    const date=new Date(mdate)
    const Year = date.getFullYear();
    const Month =
      date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
    const Day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
    let Format_string = "";
    Format_string = Year + "/" + Month + "/" + Day;
    return Format_string;
},
      onChange(event) {
        console.log("Calendar onChange");
        console.log(event);
        this.$emit("update:modelValue", this.format_date_yyyymmdd(this.value).replace("/","-").replace("/","-"));
        this.$emit("change", this.format_date_yyyymmdd(this.value).replace("/","-").replace("/","-"));
      },
    },
  };
  </script>
  <style scoped>
   
     
  .p-datepicker {
      width: auto;
      position: absolute;
      top: 166px !important;
      left: 0;
       
  }
  </style>
  